import { TmAddress } from '@/tscapi/model/account';
import { TmAccountRequest } from '@/tscapi/model/request/account-request';

export function formatAddress(address) {
    const formattedAddress = new TmAddress();

    if (address) {
        formattedAddress.Street = address.address;
        formattedAddress.AddressRef1 = address.address2;
        formattedAddress.City = address.city;
        formattedAddress.FirstName = address.firstname;
        formattedAddress.LastName = address.lastname;
        formattedAddress.State = address.province;
        formattedAddress.DayPhone = address.dayphone.trim().replace(/[-()\s]/g, '');
        formattedAddress.ZipCode = address.postalcode.trim().replace(/[\s]/g, '');
        formattedAddress.Id = 0;
        formattedAddress.IsDefault = address.defaultShipping;
        // formattedAddress.IsPOBox = false;
        // formattedAddress.POBoxNumber = '';
        // formattedAddress.SalesForceAddressId = '';
    }
    return formattedAddress;
}

export function formatCreateAddress(address) {
    const formattedAddress: TmAccountRequest = {
        Address1: address.address,
        Address2: address.address2,
        City: address.city,
        FirstName: address.firstname,
        LastName: address.lastname,
        Province: address.province,
        Phone: address.dayphone.trim().replace(/[-()\s]/g, ''),
        PostalCode: address.postalcode.trim().replace(/[\s]/g, ''),
        IsGuest: false,
        IsPhoneCustomer: false,
        IsPOBox: false,
        POBox: '',
        CustomerNumber: '',
        Email: '',
        Subscribe: false,
        Password: '',
        RetypedPassword: '',
        ReCaptchaToken: '',
        CustomerEdp: null,
    };

    return formattedAddress;
}

//since radix checkbox supports 3 states (true,false, indeterminate) we need to convert it to boolean

export function convertToBoolean(value: boolean | 'indeterminate'): boolean {
    if (value === 'indeterminate') {
        // Map 'indeterminate' to a boolean value for your API
        // For example, you might choose to treat it as `false`
        return false;
    } else {
        // If value is true or false, return it directly
        return value;
    }
}
